<mat-dialog-content>
  <div class="spinner-center loading adf-login-card-wide">
      <div class="mb20 center">{{ title | translate }}</div>
      <mat-spinner></mat-spinner>
  </div>
</mat-dialog-content>